export const selectIsSocketDisconnected = ({ socket: { isDisconnected } }) => isDisconnected;
